export default __webpack_public_path__ + "static/media/right-arrow-blue.40ad65f8.svg";